export function calcNext(turnPage, turnNext, paging, limit) {
  if (!turnPage) {
    return undefined
  }

  return turnNext ? paging.next : paging.startRow - limit
}
